document.documentElement.style.setProperty("--fdhk-brand-color", "#8C3C7A");

document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("fdhk-desc-toggle-style")) {
    const style = document.createElement("style");
    style.id = "fdhk-desc-toggle-style";
    style.textContent = `
      .product-desc, .product-desc-zh { margin: 0 !important; }

      /* When collapsed, hide only the spacer <p> after description */
      .desc-spacer--hidden { display: none !important; }

      /* List show/hide */
      .desc-list--hidden { display: none !important; }

      /* Button spacing (use padding for predictable mobile spacing + bigger tap area) */
      .desc-toggle-anchor{
        margin: 0 !important;
        padding-top: 20px !important;    /* more space above Show More */
        padding-bottom: 0px !important;  /* less space below Show More */
      }

      .desc-toggle__btn{
        appearance:none;
        background: var(--fdhk-brand-color);
        border:0;
        border-radius:2px;
        padding:4px 10px;
        margin:0;
        cursor:pointer;
        font:inherit;
        font-weight:500;
        color:#fff !important;
        display:inline-flex;
        align-items:center;
        gap:6px;
      }
      .desc-toggle__arrow{
        font-size: 12px;
        line-height: 1;
        transform: translateY(-1px);
        display:inline-block;
      }
      .desc-toggle__btn:hover{opacity:.85;}
    `;
    document.head.appendChild(style);
  }

  const makePreview = (text, mode, limit) => {
    const full = (text || "").trim();
    if (!full) return { full: "", preview: "", truncated: false };

    if (mode === "words") {
      const words = full.split(/\s+/);
      if (words.length <= limit) return { full, preview: full, truncated: false };
      return { full, preview: words.slice(0, limit).join(" ") + "…", truncated: true };
    }

    if (full.length <= limit) return { full, preview: full, truncated: false };
    return { full, preview: full.substring(0, limit) + "…", truncated: true };
  };

  const findNextDescriptionList = (desc) => {
    let node = desc.nextElementSibling;
    for (let i = 0; i < 40 && node; i++) {
      if (node.classList && node.classList.contains("description-list")) return node;
      node = node.nextElementSibling;
    }
    const parent = desc.parentElement;
    return parent ? parent.querySelector(".description-list") : null;
  };

  // Find the spacer <p>&nbsp;</p> directly after description (but DO NOT delete)
  const findSpacerP = (desc) => {
    let node = desc.nextElementSibling;
    for (let i = 0; i < 6 && node; i++) {
      if (node.tagName === "P") {
        const txt = (node.textContent || "").replace(/\u00A0/g, "").trim();
        const html = (node.innerHTML || "").replace(/&nbsp;/g, "").trim();
        if (!txt && !html) return node; // empty spacer p
      }
      // stop once we hit the list
      if (node.classList && node.classList.contains("description-list")) break;
      node = node.nextElementSibling;
    }
    return null;
  };

  // Clean duplicates
  document.querySelectorAll(".desc-toggle__btn").forEach((b) => b.remove());
  document.querySelectorAll(".desc-toggle-anchor").forEach((a) => a.remove());

  document.querySelectorAll(".product-desc, .product-desc-zh").forEach((desc) => {
    const isZh = desc.classList.contains("product-desc-zh");
    const cfg = isZh
      ? { mode: "chars", limit: 50, more: "顯示更多", less: "顯示更少" }
      : { mode: "words", limit: 20, more: "Show More", less: "Show Less" };

    const spacerP = findSpacerP(desc);
    const descList = findNextDescriptionList(desc);
    const { full, preview, truncated } = makePreview(desc.textContent, cfg.mode, cfg.limit);

    if (!truncated && !descList) return;

    // Create fixed anchor after descList (or desc if no list)
    const anchor = document.createElement("div");
    anchor.className = "desc-toggle-anchor";
    if (descList) descList.insertAdjacentElement("afterend", anchor);
    else desc.insertAdjacentElement("afterend", anchor);

    // Collapse by default
    desc.dataset.full = full;
    desc.dataset.preview = preview;
    desc.textContent = preview;
    desc.classList.add("is-collapsed");

    if (descList) descList.classList.add("desc-list--hidden");

    // Hide spacer only when collapsed (keep it in DOM)
    if (spacerP) spacerP.classList.add("desc-spacer--hidden");

    // Button
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "desc-toggle__btn";
    btn.setAttribute("aria-expanded", "false");

    const label = document.createElement("span");
    label.textContent = cfg.more;

    const arrow = document.createElement("span");
    arrow.className = "desc-toggle__arrow";
    arrow.textContent = "▼";

    btn.appendChild(label);
    btn.appendChild(arrow);
    anchor.appendChild(btn);

    btn.addEventListener("click", () => {
      const collapsed = desc.classList.toggle("is-collapsed");

      if (collapsed) {
        desc.textContent = desc.dataset.preview;
        label.textContent = cfg.more;
        arrow.textContent = "▼";
        btn.setAttribute("aria-expanded", "false");
        if (descList) descList.classList.add("desc-list--hidden");
        if (spacerP) spacerP.classList.add("desc-spacer--hidden"); // hide spacer again
      } else {
        desc.textContent = desc.dataset.full;
        label.textContent = cfg.less;
        arrow.textContent = "▲";
        btn.setAttribute("aria-expanded", "true");
        if (descList) descList.classList.remove("desc-list--hidden");
        if (spacerP) spacerP.classList.remove("desc-spacer--hidden"); // show spacer
      }
    });
  });
});
